import * as Yup from 'yup';
import { validUSState } from 'common/helpers/yup-helpers';

Yup.addMethod(Yup.mixed, 'validUSState', validUSState);

const RELATIONSHIPS_WITH_LOCATION = [
  'personOrOrganization',
  'mortgageeCoOwner',
  'managerOrLessorOfPremises',
  'lossPayee',
  'landlord',
  'occupant',
  'trustCorpsEtc',
  'landContractHolder',
  'partnerOrCoOwner',
  'additionalInterest'
];

const RELATIONSHIPS_WITH_RISKS = ['trustCorpsEtc', 'landContractHolder', 'partnerOrCoOwner', 'additionalInterest'];

const RELATIONSHIPS_WITH_EQUIPMENT = [
  'lessorOfLeasedEquipment',
  'landContractHolder',
  'partnerOrCoOwner',
  'additionalInterest'
];

const RELATIONSHIPS_WITH_SPP = ['partnerOrCoOwner', 'additionalInterest'];

const RELATIONSHIPS_WITH_RPS = ['partnerOrCoOwner', 'additionalInterest'];

const getVisibleArrayFields = (relationship) => {
  const fields = [];
  if (RELATIONSHIPS_WITH_LOCATION.includes(relationship)) {
    fields.push('locations');
  }
  if (RELATIONSHIPS_WITH_RISKS.includes(relationship)) {
    fields.push('risks');
  }
  if (RELATIONSHIPS_WITH_EQUIPMENT.includes(relationship)) {
    fields.push('equipment');
  }
  if (RELATIONSHIPS_WITH_SPP.includes(relationship)) {
    fields.push('sppItems');
  }
  if (RELATIONSHIPS_WITH_RPS.includes(relationship)) {
    fields.push('rpsItems');
  }
  return fields;
};

const hasAnyVisibleSelection = (parent) => {
  const visibleFields = getVisibleArrayFields(parent.relationship);
  return visibleFields.some((field) => (parent[field] || []).length > 0);
};

const chipArrayValidation = (relationshipList, entityLabel) =>
  Yup.array().when('relationship', {
    is: (val) => relationshipList.includes(val),
    then: Yup.array().test(
      'at-least-one-chip-selected',
      `Select all that apply. At least one item needs to be associated from the ${entityLabel} to apply this relationship type.`,
      function () {
        return hasAnyVisibleSelection(this.parent);
      }
    ),
    otherwise: Yup.array().nullable()
  });

export const getFarmInterestedPartyItemSchema = (isPolicy) => {
  const entityLabel = isPolicy ? 'policy' : 'offer';
  return Yup.object().shape({
    name: Yup.string().required('Name or Company is required').nullable(),
    relationship: Yup.string().required('Relationship is required').nullable(),
    address: Yup.object()
      .shape({
        address: Yup.string().required('Address is required').nullable(),
        address2: Yup.string().nullable(),
        city: Yup.string().required('City is required').nullable(),
        state: Yup.string().validUSState('farm-interested-party.state').required('State is required').nullable(),
        zip: Yup.string().required('Zip is required').nullable()
      })
      .required()
      .nullable(),
    locations: chipArrayValidation(RELATIONSHIPS_WITH_LOCATION, entityLabel),
    risks: chipArrayValidation(RELATIONSHIPS_WITH_RISKS, entityLabel),
    equipment: chipArrayValidation(RELATIONSHIPS_WITH_EQUIPMENT, entityLabel),
    sppItems: chipArrayValidation(RELATIONSHIPS_WITH_SPP, entityLabel),
    rpsItems: chipArrayValidation(RELATIONSHIPS_WITH_RPS, entityLabel),
    entityType: Yup.string()
      .nullable()
      .when('relationship', {
        is: 'partnerOrCoOwner',
        then: Yup.string().required('Entity Type is required'),
        otherwise: Yup.string().nullable()
      })
  });
};

export const getValidationSchema = (isPolicy) => {
  const entityLabel = isPolicy ? 'policy' : 'offer';
  return Yup.object().shape({
    name: Yup.string().required('Name or Company is required'),
    relationship: Yup.string().required('Relationship is required'),
    address: Yup.string().ensure().required('Address is required'),
    address2: Yup.string().nullable(),
    city: Yup.string().nullable().required('City is required'),
    state: Yup.string().ensure().validUSState('farm-interested-party.state').required('State is required'),
    zip: Yup.string().nullable().required('Zip is required'),
    locations: chipArrayValidation(RELATIONSHIPS_WITH_LOCATION, entityLabel),
    risks: chipArrayValidation(RELATIONSHIPS_WITH_RISKS, entityLabel),
    equipment: chipArrayValidation(RELATIONSHIPS_WITH_EQUIPMENT, entityLabel),
    sppItems: chipArrayValidation(RELATIONSHIPS_WITH_SPP, entityLabel),
    rpsItems: chipArrayValidation(RELATIONSHIPS_WITH_RPS, entityLabel),
    entityType: Yup.string()
      .nullable()
      .when('relationship', {
        is: 'partnerOrCoOwner',
        then: Yup.string().required('Entity Type is required'),
        otherwise: Yup.string().nullable()
      })
  });
};
